export default "/packs/2ceb1c8dac324e69df6e7f6c93aa8af8.svg";